<template>
  <v-navigation-drawer
    id="appDrawer"
    :temporary="$vuetify.breakpoint.smAndDown"
    :permanent="$vuetify.breakpoint.mdAndUp"
    app
    v-model="drawer"
    width="260"
  >
    <v-list v-if="user">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title
            class="body-1 font-weight-bold"
            v-text="user.name"
          />
          <v-list-item-subtitle v-text="`Coopermais`" />
        </v-list-item-content>
        <v-list-item-action>
          <v-btn
            icon
            small
            @click.stop="updateLogged"
          >
            <v-icon>
              info
            </v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-divider />
    <perfect-scrollbar>
      <v-list
        nav
        flat
        dense
      >
        <v-list-item-group
          v-for="(sessao) in itemsMenu"
          :key="sessao.header"
          color="primary"
        >
          <v-subheader v-text="sessao.header" />
          <v-list-item
            v-for="(item) in sessao.items"
            :key="item.route"
            :to="{name: item.route}"
            :disabled="!item.offline && isOffline"
            v-show="(typeof item.roles === 'boolean') ? item.roles : item.roles.includes(user.role)"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
        <v-list-item-group color="primary">
          <v-subheader v-text="`Sessão`" />
          <v-list-item @click="logout">
            <v-list-item-icon>
              <v-icon>exit_to_app</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Desconectar</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </perfect-scrollbar>
  </v-navigation-drawer>
</template>
<script>
import itemsMenu from '@/util/menu'
import { VueOfflineMixin } from 'vue-offline'
import { mapActions, mapGetters } from 'vuex'
import { eventBus } from '@/main'
export default {
  name: 'AppDrawer',
  data () {
    return {
      drawer: false,
      itemsMenu
    }
  },
  mixins: [VueOfflineMixin],
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    ...mapActions(['signout']),
    logout: function () {
      this.signout()
    },
    updateLogged: function () {
      this.$router.push({
        name: 'logado-update'
      })
    }
  },
  created () {
    eventBus.$on('APP_DRAWER_TOGGLED', () => {
      this.drawer = !this.drawer
    })
  }
}
</script>
